module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cd-timeline-block"
  }, [_c('div', {
    staticClass: "cd-timeline-img",
    class: [_vm.cd_cls]
  }), _vm._v(" "), _c('div', {
    staticClass: "cd-timeline-content"
  }, [_c('h2', [_vm._v("Day " + _vm._s(_vm.day) + " "), _c('i', {
    staticClass: "ion-arrow-down-b"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.schedules), function(schedule) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('a', [_vm._v(_vm._s(schedule.content))])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-57b61f4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/TimelineBlock.vue
// module id = 101
// module chunks = 0